import {Component} from '@angular/core';
import {environment} from 'src/environments/environment';
import {SlsStatus} from 'src/app/interfaces/sls-machine';

@Component({
    selector: 'app-slsstatus',
    templateUrl: './slsstatus.page.html',
    styleUrls: ['./slsstatus.page.scss'],
})
export class SlsstatusPage {
    // declare variables
    public date: any;
    public assets = environment.assets;
    public refreshIcon = false;
    public status_url = environment.slsstatus;
    public slsstatus: SlsStatus;
    public beamhistory: any = [];
    public times: any;
    public options: any = {};
    public updated: any;

    // refreshes the data
    public doRefresh() {
        this.refreshIcon = true;
        this.date = Date.now();
        setTimeout(() => {
            this.status_url = environment.slsstatus + this.date;
            this.refreshIcon = false;
        }, 2000);
    }


    // configuration of the chart
    public prepareGraphic() {
        this.options = {
            // color of the graph
            color: ['#b4b4b4'],
            // information of the axis
            tooltip: {
                triggerOn: 'none'
            },
            // tools from the graph (zoom etc.)
            toolbox: {
                left: 'center',
                itemSize: 25,
                orient: 'horizontal',
                feature: {
                    dataZoom: {
                        title: {
                            zoom: 'Area Zooming',
                            back: 'Restore Area Zooming'
                        },
                        yAxisIndex: 'none'
                    },
                    restore: {
                        title: 'Restore '
                    },
                    saveAsImage: {
                        show: false,
                        title: 'Save as PNG'
                    }
                }
            },
            // x-axis of the graph - Time
            xAxis: {
                data: this.times,
                boundaryGap: false,
                name: 'Time',
                nameLocation: 'middle',
                nameGap: -15,
                splitLine: {
                    show: false
                },
                axisLabel: {
                    color: '#949494'
                },
                axisPointer: {
                    snap: true,
                    lineStyle: {
                        color: '#444',
                        opacity: 0.5,
                        width: 2
                    },
                    label: {
                        show: true,
                        backgroundColor: 'rgb(128, 128, 128, 0.5)',
                        fontFamily: 'Fira Sans'
                    },
                    handle: {
                        show: true,
                        color: '#444',
                        margin: 60
                    }
                }
            },
            // y-axis of the graph - beam current (mA)
            yAxis: {
                name: 'Beam Current (mA)',
                nameLocation: 'middle',
                nameGap: -15,
                nameRotate: -90,
                type: 'value',
                min: 0,
                max: this.beamhistory[0] + 10,
                boundaryGap: [0, '100%'],
                splitLine: {
                    show: false
                },
                axisLabel: {
                    color: '#949494'
                },
            },
            // data from the y-axis
            series: [{
                type: 'line',
                smooth: true,
                itemStyle: {normal: {areaStyle: {type: 'default'}}},
                data: this.beamhistory
            }],
            // style of the general graph
            grid: {
                left: '15%',
                bottom: 90
            },
            // text style of the general graph
            textStyle: {
                fontFamily: 'Fira Sans'
            }
        };
    }

    // create time array for the graph
    public pushTime() {
        let now = new Date();
        for (let i = this.beamhistory.length - 1; i >= 0; i--) {
            let timeArray = [];
            timeArray[i] = new Date((+now) - i * 60000);
            timeArray.map(date => {
                this.times.push(`${date.getFullYear()}-${date.getMonth() + 1 < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()}\n${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}:${date.getSeconds() < 10 ? "0" : ""}${date.getSeconds()}`)
                this.updated = this.times[this.times.length - 1];
            })
        }
    }


}
